import { NgModule } from "@angular/core";
import { SpinnerBaseComponent } from "@app/components/spinner/spinner.base.component";
import { SpinnerReconnectComponent } from "@app/components/spinner/spinner.reconnect.component";
import { NetworkErrorInternalComponent } from "@app/components/networkError/network.error.internal.component";
import { NetworkErrorTimeoutComponent } from "@app/components/networkError/network.error.timeout.component";
import { NetworkErrorDisconnectedComponent } from "@app/components/networkError/network.error.disconnected.component";
import { DialogOkayCancelComponent } from "@app/components/sharedDialogs/dialogOkayCancel.component";
import { DialogPreCancelComponent } from "@app/components/sharedDialogs/dialogPreCancel.component";
import { PaymentDeclinedDialog } from "@app/components/sharedDialogs/payment-declined.dialog";
import { OneButtonDialogComponent } from "@app/components/sharedDialogs/oneButtonDialog.component";
import { DialogUserNameComponent } from "@app/components/sharedDialogs/dialogUserName.component";
import { PaymentScheduleSelectorDialog } from "@app/components/paymentSchedule/paymentScheduleSelector.dialog";
import { DialogErrorDialog } from "@app/components/sharedDialogs/dialogError.dialog";
import { ScheduleOverlapDialog } from "@app/pages/payment/schedule-overlap.dialog";
import { StopHoldMigrateDialogComponent } from "@app/pages/properties/landing/stopHoldMigrate.dialog";
import {
    ExpandedPaymentHistoryDetailDialog
} from "@app/components/expandedPaymentHistoryDetail/expandedPaymentHistoryDetail.dialog";
import { AmenityNoteDialog } from "@app/components/selectAmenities/amenity-note.dialog";
import { NoPaymentMethodDialogComponent } from "@app/pages/properties/landing/noPaymentMethod.dialog";
import { FeeChangeWarningDialog } from "@app/pages/payment/scheduleEdit/feeChangeWarningDialog";
import { ScheduleViewDeleteDialog } from "@app/pages/payment/scheduleView/scheduleViewDialogDelete";
import { CardCcvHelperDialog } from "@app/pages/guestpayment/guestpaymentcard/dialogs/card-ccv-helper.dialog";
import { DetailsPropagateDefaultDialog } from "@app/pages/wallet/dialogs/details-propagate-default.dialog";
import { PaymentErrorDialog } from "@app/components/sharedDialogs/dialogPaymentError.component";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "@app/app-routing.module";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { PipesModule } from "@app/pipes/pipes.module";
import { SharedComponentModule } from "@app/components/shared.component.module";
import { MaterialModule } from "@app/components/material.module";
import { DirectivesModule } from "@app/components/directives.module";
import { ServicesModule } from "@app/services/services.module";
import { TermsDialog } from "@app/pages/registration/terms.dialog";
import { SecurityQuestionsConfirmDialog } from "@app/pages/registration/securityQuestionsConfirm.dialog";
import { RegistrationAltDetailsCouponDialog } from "@app/pages/registration/registrationAltDetailsCoupon.dialog";
import { RegistrationFoundPropertyDialog } from "@app/pages/registration/registrationFoundProperty.dialog";
import { RegistrationAltAddressDialog } from "@app/pages/registration/registrationDialogAltAddress.component";
import {
    RegistrationAltAddressNeedsCorrectionDialog
} from "@app/pages/registration/registrationDialogAltAddressNeedsCorrection.component";
import { RegistrationInvalidAddressDialog } from "@app/pages/registration/registrationDialogInvalidAddress.component";
import { RegistrationNoPropertyDialog } from "@app/pages/registration/registrationDialogNoProperty.component";
import { RegistrationStopHoldDialog } from "@app/pages/registration/registrationDialogStopHold.component";
import {
    CheckingAccountDetailsWithSchedulesDeleteDialog
} from "@app/pages/wallet/viewcheckdetails/checkingAccountDetailsWithSchedulesDelete.dialog";
import {
    CheckingAccountDetailsDeleteDialog
} from "@app/pages/wallet/viewcheckdetails/checkingAccountDetailsDelete.dialog";
import { CheckRoutingNumberHelperDialog } from "@app/pages/wallet/checkadd/checkRoutingNumberHelper.dialog";
import { CheckAccountNumberHelperDialog } from "@app/pages/wallet/checkadd/checkAccountNumberHelper.dialog";
import { CardDetailsDeleteDialog } from "@app/pages/wallet/editcarddetails/cardDetailsDelete.dialog";
import { RegistrationStopProcessDialog } from "@app/pages/registration/registrationDialogStopProcess.component";
import {
    CardDetailsWithSchedulesDeleteDialog
} from "@app/pages/wallet/viewcarddetails/cardDetailsWithSchedulesDelete.dialog";
import { RegistrationEasyNoPropertyDialog } from "@app/pages/registration/easy/registrationEasyNoProperty.dialog";
import { AccountDeclinedDialog } from "@app/pages/wallet/checkadd/accountDeclined.dialog";
import { PaymentDateHelperDialog } from "@app/pages/payment/scheduleView/paymentDateHelper.dialog";
import { ScheduleViewCancelDialog } from "@app/pages/payment/scheduleView/scheduleViewCancel.dialog";
import { ScheduleViewRestoreDialog } from "@app/pages/payment/scheduleView/scheduleViewRestore.dialog";
import { PropertydetailsRemoveDialog } from "@app/pages/properties/propertydetails/propertydetailsRemoveDialog.component";
import { PropertydetailsMovedDialog } from "@app/pages/properties/propertydetails/propertydetailsMovedDialog.component";
import { RegistrationAssociationIdHelperDialog } from "@app/pages/registration/registrationAssociationIdHelper.component";
import { RegistrationManagementIdHelperDialog } from "@app/pages/registration/registrationManagementIdHelper.component";
import { RegistrationPropertyIdHelperDialog } from "@app/pages/registration/registrationPropertyIdHelper.component";
import { BankTokenErrorHelperDialog } from "@app/pages/guestpayment/guestpaymentcard/dialogs/bankTokenErrorHelper.dialog";

@NgModule({
    declarations: [
        SpinnerBaseComponent,
        SpinnerReconnectComponent,
        NetworkErrorInternalComponent,
        NetworkErrorTimeoutComponent,
        NetworkErrorDisconnectedComponent,
        DialogOkayCancelComponent,
        DialogPreCancelComponent,
        PaymentDeclinedDialog,
        OneButtonDialogComponent,
        DialogUserNameComponent,
        PaymentScheduleSelectorDialog,
        DialogErrorDialog,
        ScheduleOverlapDialog,
        StopHoldMigrateDialogComponent,
        ExpandedPaymentHistoryDetailDialog,
        AmenityNoteDialog,
        NoPaymentMethodDialogComponent,
        FeeChangeWarningDialog,
        ScheduleViewDeleteDialog,
        CardCcvHelperDialog,
        DetailsPropagateDefaultDialog,
        PaymentErrorDialog,
        TermsDialog,
        SecurityQuestionsConfirmDialog,
        RegistrationNoPropertyDialog,
        RegistrationAltAddressNeedsCorrectionDialog,
        RegistrationAltAddressDialog,
        RegistrationAltDetailsCouponDialog,
        RegistrationInvalidAddressDialog,
        RegistrationStopHoldDialog,
        RegistrationFoundPropertyDialog,
        CheckingAccountDetailsWithSchedulesDeleteDialog,
        CheckingAccountDetailsDeleteDialog,
        CheckRoutingNumberHelperDialog,
        CheckAccountNumberHelperDialog,
        CardDetailsDeleteDialog,
        RegistrationStopProcessDialog,
        CardDetailsWithSchedulesDeleteDialog,
        RegistrationEasyNoPropertyDialog,
        AccountDeclinedDialog,
        PaymentDateHelperDialog,
        ScheduleViewCancelDialog,
        ScheduleViewRestoreDialog,
        PropertydetailsRemoveDialog,
        PropertydetailsMovedDialog,
        RegistrationAssociationIdHelperDialog,
        RegistrationManagementIdHelperDialog,
        RegistrationPropertyIdHelperDialog,
        BankTokenErrorHelperDialog
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        HttpClientModule,
        BrowserAnimationsModule,
        PipesModule,
        SharedComponentModule,
        MaterialModule,
        DirectivesModule,
        ServicesModule,
    ]
})
export class DialogModule{}
